module.exports = __webpack_public_path__ + "img/card.82361880.jpg";